module.exports = __webpack_public_path__ + "img/netherlands.1c604b71.svg";